/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    SUPPORT_PLANS_RECEIVE,
    SUPPORT_PLANS_REQUEST,
    SUPPORT_PLANS_REQUEST_SUCCESS,
    SUPPORT_PLANS_REQUEST_FAILURE,
    CURRENT_SUPPORT_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [SUPPORT_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [SUPPORT_PLANS_REQUEST]: () => true,
    [SUPPORT_PLANS_REQUEST_SUCCESS]: () => false,
    [SUPPORT_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [SUPPORT_PLANS_REQUEST]: () => false,
    [SUPPORT_PLANS_REQUEST_SUCCESS]: () => false,
    [SUPPORT_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
